import React, { useEffect, useState } from "react";
import {
  UserGearIcon,
  TicketIcon,
  BranchUserIcon,
  DownloadIcon,
  ShieldIcon,
  ShieldUserIcon,
} from "../../assets";
import { IconPrimary } from "../../components";
import { Col, Row } from "antd";
import axiosClient from "../../api/axiosClient";
import LogsTable from "./LogsTable";

import downloadDataIExcelSheet from "../../utils/downloadDataIExcelSheet";
import handleApiError from "../../utils/handleError";

interface ILogsTypes {
  name: string;
  endpoint: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}
export default function Logs() {
  const logs: ILogsTypes[] = [
    { name: "User Logs", Icon: BranchUserIcon, endpoint: "user" },
    { name: "Admin Logs", Icon: ShieldIcon, endpoint: "admin" },
    { name: "ATC Admin Logs", Icon: UserGearIcon, endpoint: "branch" },
    { name: "Voucher Logs", Icon: TicketIcon, endpoint: "voucher" },
    { name: "Examiner Logs", Icon: ShieldUserIcon, endpoint: "examiner" },
  ];

  const [data, setData] = useState<any>([]);

  const [active, setActive] = useState(logs[0]);

  useEffect(() => {
    setData([]);
    axiosClient
      .get(`/logs/${active.endpoint}`)
      .then((res) => setData(res.data))
      .catch((err) => {
        handleApiError(err);
      });
  }, [active]);

  return (
    <>
      <Row>
        <Col flex={1}>
          <div className="logs_title">
            <h4>{active.name}</h4>
          </div>
        </Col>

        <Row gutter={[10, 10]}>
          <Col>
            <IconPrimary
              onClick={() =>
                downloadDataIExcelSheet(data, `${active?.name}_logs`)
              }
            >
              <DownloadIcon />
            </IconPrimary>
          </Col>
          {logs.map((log: ILogsTypes, index: number) => {
            const Icon = log.Icon;
            return (
              <Col onClick={() => setActive(log)} key={index}>
                <div className={active.name === log.name ? "logs_active" : ""}>
                  <IconPrimary>
                    <Icon />
                  </IconPrimary>
                </div>
              </Col>
            );
          })}
        </Row>
      </Row>

      <LogsTable logs={data} loading={false} />
    </>
  );
}
